module.exports = " <header class=header id=home _v-92b0a61c=\"\"> <section class=container _v-92b0a61c=\"\"> <div v-show=showHeader transition=fade _v-92b0a61c=\"\"> <img class=img src=/static/img/tempd.png alt=TEMPd title=TEMPd _v-92b0a61c=\"\"> <h1 class=title _v-92b0a61c=\"\">TEMPd</h1> <p class=description _v-92b0a61c=\"\"> Temporary file hosting with immediate automatic deletion when leaving the site. </p> </div> <button id=upload class=\"button no-margin-bottom\" _v-92b0a61c=\"\">Drop files or tap to upload</button> </section> </header> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-92b0a61c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
 ** module id = 126
 ** module chunks = 2
 **/